import * as Sharing from 'expo-sharing';
import { useEffect, useState } from 'react';

export default function useIsSharingAvailable() {
  const [isSharingAvailable, setIsSharingAvailable] = useState(false);

  useEffect(() => {
    (async () => {
      const isAvailable = await Sharing.isAvailableAsync();
      setIsSharingAvailable(isAvailable);
    })();
  }, []);

  return isSharingAvailable;
}
